module.exports = __webpack_public_path__ + "static/media/medium-header-bremen.18960be9.png";